"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoDetailModule = void 0;
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var mobx_react_1 = require("mobx-react");
var react_1 = tslib_1.__importDefault(require("react"));
var cards_enum_1 = require("../../Latest/Timeline/cards.enum");
var VideoDetail_1 = require("./VideoDetail");
var createCard = function (props) { return ({
    type: cards_enum_1.Cards.GS_VIDEO_CARD,
    identifier: 'base',
    video: {
        identifier: props.videoId,
    },
    tags: [],
    isFeatured: false,
    isPinned: false,
    date: props.date,
    title: props.title,
    richTitle: lodash_1.default.isEmpty(props.richTitle) ? undefined : props.richTitle,
    description: lodash_1.default.isEmpty(props.description) ? undefined : props.description,
    pillarTag: {
        title: props.pillar.name,
        backgroundColor: props.pillar.backgroundColor,
        textColor: props.pillar.textColor,
    },
    shareUrl: window.location.href,
    shareUrlTarget: 'same',
    issueDate: props.issuesDate,
    issues: props.issues,
    image: lodash_1.default.isEmpty(props.image) ? undefined : props.image,
}); };
var VideoDetailModule = /** @class */ (function (_super) {
    tslib_1.__extends(VideoDetailModule, _super);
    function VideoDetailModule(props) {
        var _this = _super.call(this, props) || this;
        if (props.globalStore) {
            var videoPageStore = props.globalStore.greenSectionStore.videoPageStore;
            var card = createCard(props);
            videoPageStore.baseCard = card;
            videoPageStore.activeCard = card;
        }
        return _this;
    }
    VideoDetailModule.prototype.render = function () {
        if (!this.props.globalStore) {
            return null;
        }
        return (react_1.default.createElement(VideoDetail_1.VideoDetail, { subscribeLink: this.props.subscribeLink, homepageUrl: this.props.homepageUrl, videoPageStore: this.props.globalStore.greenSectionStore.videoPageStore }));
    };
    VideoDetailModule = tslib_1.__decorate([
        mobx_react_1.inject('globalStore'),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], VideoDetailModule);
    return VideoDetailModule;
}(react_1.default.Component));
exports.VideoDetailModule = VideoDetailModule;
